var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManageTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.397,
    height: 22.655,
    viewBox: "0 0 20.397 22.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20489",
    "data-name": "Group 20489",
    transform: "translate(-12753.134 -5591.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49855",
    "data-name": "Path 49855",
    d: "M12769.438,5603.112v-6.737h-11.325V5612.3h4.913",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49856",
    "data-name": "Path 49856",
    d: "M12767.741,5596.6v-2.822h-12.153v17.258h2.78",
    transform: "translate(-1.554 -1.358)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49857",
    "data-name": "Path 49857",
    d: "M12760.438,5600.5h4.75",
    transform: "translate(1)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49858",
    "data-name": "Path 49858",
    d: "M12760.438,5604.337h3.775",
    transform: "translate(1 -1)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49859",
    "data-name": "Path 49859",
    d: "M12760.438,5605.417h1.738",
    transform: "translate(0.975 1)",
    fill: "none",
    stroke: "#777",
    strokeLinecap: "round",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "setting-2-svgrepo-com_1_",
    "data-name": "setting-2-svgrepo-com (1)",
    d: "M9.4,5.286c-.74,0-1.043-.524-.675-1.166a.776.776,0,0,0-.286-1.059l-.708-.4A.683.683,0,0,0,6.8,2.9l-.045.078a.711.711,0,0,1-1.346,0L5.366,2.9a.671.671,0,0,0-.924-.245l-.708.4a.781.781,0,0,0-.286,1.064c.372.638.07,1.162-.671,1.162A.779.779,0,0,0,2,6.063v.72a.779.779,0,0,0,.777.777c.74,0,1.043.524.671,1.166a.776.776,0,0,0,.286,1.059l.708.4a.683.683,0,0,0,.933-.245l.045-.078a.711.711,0,0,1,1.346,0l.045.078a.683.683,0,0,0,.933.245l.708-.4a.777.777,0,0,0,.286-1.059c-.372-.642-.07-1.166.671-1.166a.779.779,0,0,0,.777-.777v-.72A.786.786,0,0,0,9.4,5.286ZM6.09,7.753A1.329,1.329,0,1,1,7.42,6.423,1.332,1.332,0,0,1,6.09,7.753Z",
    transform: "translate(12763.346 5603.888)",
    fill: "#777"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTemplate);
export default __webpack_public_path__ + "static/media/manageTemplate.9de03d5fda13d5f7ac86ef8fdb3fac14.svg";
export { ForwardRef as ReactComponent };